module.exports = __webpack_public_path__ + "img/Path 8@3x.9bb81fdd.png";